/**
 * 渲染一张图片
 * @param {string} url - 图片链接
 * @param {Fn} callback - 要执行的方法
 */
const render_img = (url) => {
    return new Promise((res, rej) => {
        if (url) {
            let img = new Image();
            img.onload = () => {
                res({ width: img.width, height: img.height });
            };

            img.onerror = () => {
                rej(new Error(`Could not load image at ${url}`));
            };
            img.src = url;
        }
    });
};

/**
 * 延迟操作
 * @param ms
 * @returns {Promise<any>}
 */
const timeout = (ms = 300) => {
    return new Promise((res) => {
        window.setTimeout(() => {
            res();
        }, ms);
    });
};

//  处理图片下载
// const download_picture = (fullDownloadPath) => {
//   let iframe = document.createElement("iframe");
//   iframe.style.display = "none";
//   if ("onload" in iframe) {
//     iframe.onload = iframeLoad;
//   } else if (iframe.attachEvent) {
//     iframe.attachEvent("onload", iframeLoad);
//   } else {
//     iframe.onreadystatechange = function onreadystatechange() {
//       if (iframe.readyState === "complete") {
//         iframeLoad;
//       }
//     };
//   }
//   iframe.src = "";
//   document.body.appendChild(iframe);
//   iframe.contentWindow.location.href = fullDownloadPath;
//   // iframe.parentNode.removeChild(iframe);
//   // setTimeout((iframe.contentWindow.location.href = fullDownloadPath), 50);
//   function iframeLoad() {
//     const win = iframe.contentWindow;
//     const doc = win.document;
//     if (win.location.href === fullDownloadPath) {
//       if (doc.body.childNodes.length > 0) {
//         // response is error
//       }
//       iframe.parentNode.removeChild(iframe);
//     }
//   }
// };
const download_picture = (fullDownloadPath, name) => {
    let random = Math.round(Math.random() * 10000);
    let a = document.createElement("a");
    a.id = `down-${random}`;
    a.href = fullDownloadPath;
    a.download = name;
    a.style.display = "none";
    document.body.appendChild(a);
    document.getElementById(`down-${random}`).click();
    setTimeout(() => {
        document.getElementById(`down-${random}`).remove();
    }, 1000);

    // window.open(fullDownloadPath, "_self")
};

/**
 * 获取 422 响应中的第一条错误消息
 *
 * @param res 响应
 * @returns {*}
 */
const getFirstError = (res) => {
    if (res.status === 422) {
        return Object.values(res.data.errors)[0][0];
    } else {
        return "";
    }
};

/**
 * 把 laravel 返回的错误消息，处理成只有一条
 *
 * @param res 响应
 */
const handleValidateErrors = (res) => {
    let errors = {};
    if (res && (res.status === 422 || res.status === 429)) {
        ({ errors } = res.data);
        if (!errors) {
            return {};
        }
        Object.keys(errors).forEach((k) => {
            errors[k] = errors[k][0];
        });
    }

    return errors;
};

// Get localStorage
const get_storage = (key) => {
    if ("localStorage" in window) {
        try {
            return window.localStorage.getItem(key);
        } catch (error) {
            return "";
        }
    }
};

// set localStorage
const set_storage = (key, value) => {
    if ("localStorage" in window) {
        try {
            window.localStorage.setItem(key, value);
        } catch (error) {
            return "";
        }
    }
};

const get_days = () => {
    //构造当前日期对象
    let date = new Date();
    let year = date.getFullYear(); //获取年份
    let mouth = date.getMonth() + 1; //获取当前月份
    let days; //定义当月的天数；
    if (mouth == 2) {
        //当月份为二月时，根据闰年还是非闰年判断天数
        days = year % 4 == 0 ? 29 : 28;
    } else if (
        mouth == 1 ||
        mouth == 3 ||
        mouth == 5 ||
        mouth == 7 ||
        mouth == 8 ||
        mouth == 10 ||
        mouth == 12
    ) {
        //月份为：1,3,5,7,8,10,12 时，为大月.则天数为31；
        days = 31;
    } else {
        //其他月份，天数为：30.
        days = 30;
    }
    return days;
};

Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S+": this.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.lenght)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};

//对字符串进行加密
const compileStr = (code) => {
    var c = String.fromCharCode(code.charCodeAt(0) + code.length);
    for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
    }
    return escape(c);
};

//字符串进行解密
const uncompileStr = (code) => {
    code = unescape(code);
    var c = String.fromCharCode(code.charCodeAt(0) - code.length);
    for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
    }
    return c;
};

export {
    render_img,
    timeout,
    download_picture,
    getFirstError,
    handleValidateErrors,
    set_storage,
    get_storage,
    get_days,
    compileStr,
    uncompileStr,
};
